import { Button, CharField, Flex, H1, SingleSelectField, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import type { FiltersBase } from "../../types"
import { useNavigate } from "react-router-dom"
import { useQsFilters } from "../../hooks/filters"
import { TableDocuments } from "./TableDocuments"
import { useDocumentsList } from "../../hooks/documents"
import { EVENT_TYPES } from "../../constants"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "name",
    event_types: params.get("event_types") ?? "",
    draft: params.get("draft") ?? "",
  } as FiltersBase & { event_types: string; draft: string })

export default function Documents() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = useDocumentsList({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
    event_types: filters.event_types,
    draft: filters.draft,
  })

  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Documenti" }])

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Documenti</H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/documents/documents/new")
            }}
          />
        </Flex>
        <Flex className="mb-3">
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value, page: 1 })
            }}
          />
          <SingleSelectField
            label=""
            clearable
            placeholder="Tipo di evento"
            className="ms-2"
            style={{
              width: 300,
              zIndex: 9999,
            }}
            value={EVENT_TYPES.find((type) => type.value === filters.event_types) || null}
            options={[{ label: "Tutti", value: "" }, ...EVENT_TYPES]}
            onChange={(value) => {
              setFilters({ ...filters, event_types: (value?.value as string) || "", page: 1 })
            }}
          />
          <SingleSelectField
            label=""
            clearable
            placeholder="Stato bozza"
            className="ms-2"
            style={{
              width: 300,
              zIndex: 9998,
            }}
            value={
              [
                { label: "Bozza", value: "true" },
                { label: "Pubblicato", value: "false" },
              ].find((status) => status.value === filters.draft) || null
            }
            options={[
              { label: "Bozza", value: "true" },
              { label: "Pubblicato", value: "false" },
            ]}
            onChange={(value) => {
              setFilters({ ...filters, draft: (value?.value as string) || "", page: 1 })
            }}
          />
        </Flex>
        <TableDocuments
          documents={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
